import PropTypes from 'prop-types'
import { Box, Icon, Text, TransparentButton } from '@redriverpress/system'
import {
  CONTENT_TYPES,
  CONTENT_LABELS,
  COURSE_TYPE_LABELS,
} from 'Common/constants/contentTypes'

import CardCoverImage from './CardCoverImage'

export default function ContentCard({
  isLink,
  level,
  onClick,
  path,
  image,
  title,
  type,
  courseType,
  ...props
}) {
  const isCourseType = type === CONTENT_TYPES.course

  return (
    <TransparentButton
      as={isLink ? 'a' : 'button'}
      href={path}
      onClick={onClick}
      borderRadius='small'
      bg='white'
      display='flex'
      p={3}
      {...props}
    >
      <CardCoverImage
        mr={2}
        width={isCourseType ? '37px' : undefined}
        height={isCourseType ? '28px' : undefined}
        borderRadius={isCourseType ? 'small' : undefined}
        src={image}
        flex='none'
        alt={`Thumbnail image for ${CONTENT_LABELS[type]}: ${title}`}
        contentType={type}
      />

      <Box>
        <Text as='span' display='flex' color='gray700' fontWeight='600' mb={1}>
          {isCourseType ? COURSE_TYPE_LABELS[courseType] : CONTENT_LABELS[type]}
        </Text>
        <Text textAlign='left' fontWeight='600'>
          {title}
        </Text>
        {level && (
          <Box
            color='gray700'
            display='flex'
            justifyContent='flex-start'
            alignItems='center'
            fontSize={0}
          >
            <Icon icon='lightbulb' mr={2} />
            <Text>{level}</Text>
          </Box>
        )}
      </Box>
    </TransparentButton>
  )
}

ContentCard.defaultProps = {
  onClick: null,
  path: null,
  isLink: false,
  level: null,
  image: null,
  courseType: null,
}

ContentCard.propTypes = {
  isLink: PropTypes.bool,
  level: PropTypes.string,
  onClick: PropTypes.func,
  path: PropTypes.string,
  image: PropTypes.string,
  title: PropTypes.string.isRequired,
  courseType: PropTypes.oneOf(Object.keys(COURSE_TYPE_LABELS)),
  type: PropTypes.oneOf([
    CONTENT_TYPES.flashcardCategory,
    CONTENT_TYPES.flashcardSet,
    CONTENT_TYPES.lesson,
    CONTENT_TYPES.course,
    CONTENT_TYPES.video,
  ]).isRequired,
}
